/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ErrorMessage } from '../../common';
import actions from '../../../actions';
import { getErrorMessages } from "../../../utils";

class SendSMSContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messageText: null,
            count: 0,
            sending: false,
            error: null,
        };
        this.sendMessage = this.sendMessage.bind(this);
    }

    handleMessageTextChange = event => {
        this.setState({
            messageText: event.target.value,
            count: event.target.value.length,
        });
    };

    sendMessage = () => {
        this.setState({ sending: true });
        this.props.sendSMS(
            this.props.freelancers.map(fl => fl.id),
            this.props.exclusive,
            this.props.location.search,
            this.state.messageText,
            this.props.isUnallocatedFreelancersRoute,
            response => {
                const successMessage = response.data.content.sent
                    ? `Successfully sent message to ${response.data.content.sent} workers`
                    : this.props.freelancers.length == 1
                    ? `Successfully sent message to ${this.props.freelancers[0].full_name}`
                    : 'Successfully sent message';
                this.props.notification.success('Success', successMessage);
                this.props.closeModal();
                this.props.onActionSuccess();
            },
            error => {
                this.setState({
                    sending: false,
                    error: getErrorMessages(error),
                });
            },
        );
    };

    render() {
        const countOfSelected = this.props.exclusive
            ? this.props.totalNumberOfItemsInTable -
              this.props.freelancers.length
            : this.props.freelancers.length;
        return (
            <div>
                <div className="modal-dialog sms-message-container">
                    <div className="popup-header">
                        <div
                            className="popup-header-dismiss"
                            onClick={this.props.closeModal}
                        >
                            <i className="icon icon-close" />
                        </div>
                        <h1>
                            {this.props.freelancer
                                ? `Send SMS to ${this.props.freelancer}`
                                : 'Send SMS'}
                        </h1>
                    </div>
                    <form>
                        <textarea
                            name="message"
                            onChange={this.handleMessageTextChange}
                            placeholder="Type in your message here"
                            maxLength={this.props.smsMaxLen}
                            rows="5"
                        />
                    </form>
                    <div className={`sms-message-count ${this.state.count >= this.props.smsMaxLen ? 'text-red' : ''}`}>
                        {this.state.count}{`/${this.props.smsMaxLen} characters used`}
                    </div>
                    <div className="modal-bottom-bar">
                        <button
                            className="table-action-button"
                            type="button"
                            onClick={this.sendMessage}
                            disabled={
                                !this.state.messageText || this.state.sending
                            }
                        >
                            {this.state.sending
                                ? 'Sending...'
                                : countOfSelected > 1
                                ? `Send sms to ${countOfSelected} workers`
                                : 'Send SMS'}
                        </button>
                    </div>
                </div>
                {this.state.error &&
                    <ErrorMessage message={this.state.error} />
                }
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    smsMaxLen: state.user.agency.sms_max_length,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    sendSMS: (
        recipients,
        exclusive,
        filter,
        message,
        isUnallocatedFreelancersRoute,
        successCallback,
        errorCallback,
    ) =>
        dispatch(
            actions.sendSMS({
                recipients,
                exclusive,
                filter,
                message,
                isUnallocatedFreelancersRoute,
                successCallback,
                errorCallback,
            }),
        ),
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(SendSMSContainer),
);
